import React from 'react';
import assets from '../../assets/assets';

function NoData(): React.ReactElement {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20, height: 300, justifyContent: 'center' }}>
      <img src={assets.nodata} style={{ width: 200 }} />
      <span style={{ fontWeight: 'bold', fontSize: 16 }}>Nenhum dado encontrado</span>
    </div>
  );
}

export default NoData;